import { checkCode } from '../utils/api';
import { getAssetForId } from '../selectors/assets';
import InPlayer from '@inplayer-org/inplayer.js';

export const CHECK_ACCESS_REQUEST = 'CHECK_ACCESS_REQUEST';
export const CHECK_ACCESS_SUCCESS = 'CHECK_ACCESS_SUCCESS';
export const CHECK_ACCESS_FAILURE = 'CHECK_ACCESS_FAILURE';

export const checkAccess = (id, uuid, callback = () => {}) => {
    return async (dispatch, getState) => {
        const asset = getAssetForId(id)(getState());
        if (asset && asset.hasAccess) return;

        dispatch({ type: CHECK_ACCESS_REQUEST, data: { id, uuid } });

        try {
            InPlayer.Asset.checkAccessForAsset(
                InPlayer.Account.getToken().token,
                id
            ).then(data => {
                if (checkCode(data)) {
                    dispatch({
                        type: CHECK_ACCESS_SUCCESS,
                        data: data.item,
                    });
                    callback(
                        getState().modal.assetID,
                        true,
                        getState().modal.isTriggerExternal
                    );
                } else {
                    dispatch({
                        type: CHECK_ACCESS_FAILURE,
                        data: { id, uuid },
                    });
                    callback(
                        getState().modal.assetID,
                        false,
                        getState().modal.isTriggerExternal
                    );
                }
            });
        } catch (error) {
            dispatch({
                type: CHECK_ACCESS_FAILURE,
                data: { id, uuid },
            });
        }
    };
};

export const FETCH_ASSET_SUCCESS = 'FETCH_ASSET_SUCCESS';
export const FETCH_ASSET_REQUEST = 'FETCH_ASSET_REQUEST';
export const FETCH_ASSET_FAILURE = 'FETCH_ASSET_FAILURE';

export const fetchAsset = (id, uuid) => {
    return async (dispatch, getState) => {
        const asset = getAssetForId(id)(getState());
        if (asset) {
            return null;
        }

        dispatch({ type: FETCH_ASSET_REQUEST, data: { id, uuid } });

        try {
            InPlayer.Asset.findAsset(id, uuid).then(data => {
                dispatch({ type: FETCH_ASSET_SUCCESS, data });
            });
        } catch (error) {
            dispatch({
                type: FETCH_ASSET_FAILURE,
                data: { id, uuid },
            });
        }
    };
};

export const FIND_EXTERNAL_ASSET_SUCCESS = 'FIND_EXTERNAL_ASSET_SUCCESS';
export const FIND_EXTERNAL_ASSET_REQUEST = 'FIND_EXTERNAL_ASSET_REQUEST';
export const FIND_EXTERNAL_ASSET_FAILURE = 'FIND_EXTERNAL_ASSET_FAILURE';

export const findExternalAsset = (asset, callback) => {
    return async (dispatch, getState) => {
        dispatch({ type: FIND_EXTERNAL_ASSET_REQUEST });

        try {
            InPlayer.Asset.findExternalAsset(
                asset.external.type,
                asset.external.id,
                getState().paywall.clientID
            ).then(data => {
                dispatch({ type: FIND_EXTERNAL_ASSET_SUCCESS, data });
                callback({ ...data, ...asset });
            });
        } catch (error) {
            dispatch({ type: FIND_EXTERNAL_ASSET_FAILURE, data });
        }
    };
};

export const FETCH_DLC_LINKS_SUCCESS = 'FETCH_DLC_LINKS_SUCCESS';
export const FETCH_DLC_LINKS_REQUEST = 'FETCH_DLC_LINKS_REQUEST';
export const FETCH_DLC_LINKS_FAILURE = 'FETCH_DLC_LINKS_FAILURE';

export const fetchDlcLinks = (assetId, callback) => {
    return async dispatch => {
        dispatch({ type: FETCH_DLC_LINKS_REQUEST });

        try {
            InPlayer.Misc.getDlcLinks(
                InPlayer.Account.getToken().token,
                assetId
            ).then(data => {
                dispatch({ type: FETCH_DLC_LINKS_SUCCESS, data });
                callback(data);
            });
        } catch (error) {
            dispatch({ type: FETCH_DLC_LINKS_FAILURE });
        }
    };
};



// WEBPACK FOOTER //
// ./src/actions/assets.js